import { css } from '@adornis/chemistry/directives/css.js';
import { baseConfig } from '@adornis/config/baseConfig.js';
import type { CampusExercise } from '@chancenwerk/campus-learning-content/entities/CampusExercise.js';
import '@chancenwerk/components/chancen-component-card-title.js';
import { ExerciseType } from '@chancenwerk/db/enums/enums.js';
import { html, nothing } from 'lit';
import { customElement } from 'lit/decorators.js';
import { CampusComponentExerciseEdit } from './campus-page-exercise-edit.js';

function setupSerloRoot() {
  if (document.getElementById('serlo-root')) return;

  const serloRoot = document.createElement('div');
  serloRoot.id = 'serlo-root';
  document.body.appendChild(serloRoot);
}

setupSerloRoot();

window.process = {
  env: {},
};
import('@serlo/editor-web-component').then(serlo => {
  customElements.define('serlo-editor', serlo.EditorWebComponent);
});

const initialExampleState = {
  plugin: 'rows',
  state: [
    {
      plugin: 'text',
      state: [
        {
          type: 'h',
          level: 1,
          children: [{ text: 'Beispiel überschrift' }],
        },
      ],
    },
  ],
};

/**
 * @customElement campus-page-exercise-edit-serlo-editor
 */
@customElement('campus-page-exercise-edit-serlo-editor')
export class CampusPageExerciseEditSerloEditor extends CampusComponentExerciseEdit {
  static override exerciseType: number = ExerciseType.SERLO_EDITOR;
  static override exerciseName: string = 'SERLO Editor Aufgabe';
  static override exerciseElement: string = 'campus-page-exercise-edit-serlo-editor';

  protected override getExcersiseType(): number {
    return CampusPageExerciseEditSerloEditor.exerciseType;
  }

  protected override getExcersieName(): string {
    return CampusPageExerciseEditSerloEditor.exerciseName;
  }

  constructor() {
    super();
  }

  protected override async handleFormSuccess(exercise: CampusExercise): Promise<void> {
    if (!exercise.serloEditorState || exercise.serloEditorState === '')
      return this.errorMsg.next('Serlo Editor Inhalt darf nicht leer sein!');
    return super.handleFormSuccess(exercise);
  }

  override content() {
    // ! errors from the serlo editor seem to kill the loading of the lesson
    // ! so we need to wait for the lesson to be loaded before we can render the editor
    if (!this.lesson.value) {
      return html`<cr-loader></cr-loader>`;
    }

    return html`
      ${this.errorMsg.value
        ? html`<cr-flex padding="sm"><cr-text ${css({ color: 'red' })}>${this.errorMsg.value}</cr-text></cr-flex>`
        : nothing}
      <cr-flex space="md">
        <cr-card space="md" padding="md">
          <cr-flex horizontal space="md">
            <cr-flex flex space="md">
              <cr-flex space="md" space-between>
                <cr-text>Felder mit einem * müssen ausgefüllt werden!</cr-text>
                <cr-input ${this.form.field('title')} placeholder="Titel *"></cr-input>
              </cr-flex>
            </cr-flex>
          </cr-flex>
        </cr-card>
        <cr-card ${css({ minHeight: '800px', overflow: 'auto' })} padding="xxl">
          <x-overlay ${css({ width: '96%', maxWidth: '96%', height: '700px' })} sync-back-height>
            <serlo-editor
              ${css({ height: '700px', overflow: 'auto' })}
              editor-variant="chancenwerk"
              mode="write"
              testing-secret=${'VJN8pHhqVj8RtO+TfY2/Ka1JN4JdH/oSOAdPHz5a'}
              is-production-environment=${baseConfig.get('DEPLOYMENT') === 'production'}
              initial-state=${this.exercise.value?.serloEditorState || JSON.stringify(initialExampleState)}
              @state-changed=${e => {
                if (!this.exercise.value) {
                  return;
                }
                this.exercise.value.serloEditorState = JSON.stringify(e.detail.newState);
                this.exercise.next(this.exercise.value);
              }}
            ></serlo-editor>
          </x-overlay>
        </cr-card>
      </cr-flex>
    `;
  }
}
